/* ++++++++++ --------------- IMPORTS --------------- ++++++++++ */
// import { color, pxToEm, centerAbsolutely, imageTypes, animations, mediaQuery } from 'utils/styles';
// import { url } from 'utils/urls';



/* ++++++++++ --------------- USER DATA COLLECTION STYLES --------------- ++++++++++ */
export default {
    userDataCollection: {

    }
};
